module.exports = __webpack_public_path__ + "pathways-grey-bg.50d1e4022e98cd7e30d234886cf4fa84.png";